export default "__VITE_ASSET__DCAt0Fly__"